import { ArrowBackIcon } from '../../assets';
import { IconButtonLink } from '../common/ButtonLink';
import { makeStyles } from 'tss-react/mui';

interface TitleLinkProps {
  route: string;
  title: string;
  className?: string;
}

export function TitleLink({ route, title, className }: TitleLinkProps) {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.pageHeader, className)}>
      <IconButtonLink to={route} className={classes.backIcon} size='small'>
        <ArrowBackIcon />
      </IconButtonLink>
      <span>{title}</span>
    </div>
  );
}

const useStyles = makeStyles({ name: { TitleLink } })((theme) => ({
  pageHeader: {
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: 500,
    marginBottom: 40,
  },
  backIcon: {
    color: 'inherit',
    marginRight: 7,
  },
}));
